// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/bg-menu.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/images/theme/products/super_bock.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
  background-color: #ab2429;
  /*background-color: #eee;*/
  min-height: 100%;
}
.menu .app .main-header {
  overflow: hidden;
}
.menu .app .main-header:before {
  content: "";
  display: block;
  padding-bottom: 200%;
  transition: padding 0.6s ease-in;
}
.menu .app .main-header .back {
  top: 5%;
  left: 6%;
  position: absolute;
  z-index: 2;
  text-decoration: none;
}
.menu .app .main-header .menu-logo {
  position: absolute;
  width: 19%;
  left: 50%;
  transform: translateX(-50%);
  top: 4%;
}
.menu .app .main-header .menu-logo.right {
  left: inherit;
  right: 6%;
}
.menu .app .main-header .client-logo {
  position: absolute;
  width: 34%;
  left: 11%;
  top: 34%;
}
.menu .app .main-header .placeholder {
  position: absolute;
  width: 42%;
  left: 6%;
  top: 29%;
}
.menu .app .main-header .placeholder:before {
  padding-bottom: 82%;
  display: block;
  content: "";
}
.menu .app .main-header .placeholder h1 {
  font: 2.7em/1 vigaregular;
  color: #fff;
}
.menu .app .main-header .placeholder .logo {
  width: 86%;
  left: 7%;
  top: 50%;
}
.menu .app .main-header .placeholder h1,
.menu .app .main-header .placeholder .logo {
  transform: translate(0, -50%);
  position: absolute;
  top: 50%;
}
.menu .app .main-header .cover {
  position: absolute;
  overflow: hidden;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
}
.menu .app .main-header .cover .image {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  max-height: 405px;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
}
.menu .app .main-header .cover .product {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50%;
  position: absolute;
  max-height: 354px;
  height: 100%;
  width: 50%;
  right: 0%;
  top: 25%;
  transition: all 750ms;
}
.menu .app .main-header .not-published {
  position: absolute;
  display: flex;
  opacity: 1;
  width: 45%;
  top: 56%;
  left: 6%;
}
.menu .app .main-header .lang {
  transition: opacity 0.3s;
  position: absolute;
  display: flex;
  opacity: 1;
  width: 39%;
  top: 56%;
  left: 6%;
}
.menu .app .main-header .lang a {
  font: 1.7em/1 "vigaregular";
  background-color: #fff;
  border-radius: 8px;
  color: #caa36c;
  margin: 5px;
  width: 50%;
}
.menu .app .main-header .lang a::before {
  content: "";
  display: block;
  padding-bottom: 100%;
}
.menu .app .main-header .lang a.active {
  background-color: #caa36c;
  color: #fff;
}
.menu .app .main-header .lang a span {
  transform: translate(-50%, -50%);
  position: absolute;
  left: 50%;
  top: 50%;
}
.menu .app .main-header .lang.solo a {
  width: 100%;
}
.menu .app .main-header .lang.solo a:before {
  padding-bottom: 50%;
}
.menu .app.opened .main-header::before {
  padding-bottom: 82%;
}
.menu .app.opened .main-header .lang {
  opacity: 0;
}
.menu .app.opened .main-header .note {
  display: none;
}
.menu .app.opened .main-header .cover .product {
  /*max-height: 180px;*/
  max-height: 50%;
}
.menu .app .note {
  position: absolute;
  bottom: 2%;
  text-align: center;
  width: 100%;
  font: 1em/1.2em vigaregular;
  color: #fff;
}
.menu .app .note a {
  color: #fff;
}
.menu .app .areas {
  transition: margin 0.5s;
  margin-left: 0%;
  display: flex;
  width: 200%;
}
.menu .app .areas.tab {
  width: 300%;
  margin-left: -100%;
}
.menu .app .areas.tab.opened {
  margin-left: -200%;
}
.menu .app .areas.opened {
  margin-left: -100%;
}
.menu .app .areas.opened section:first-child {
  height: 100vh;
}
.menu .app .areas section {
  width: 50%;
}
.menu .app .areas section.tab-detail .tabs {
  margin-top: -5%;
}`, "",{"version":3,"sources":["webpack://./src/components/menu/Menu.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,0BAAA;EACA,gBAAA;AACF;AAEI;EACE,gBAAA;AAAN;AAEM;EACE,WAAA;EACA,cAAA;EACA,oBAAA;EACA,gCAAA;AAAR;AAGM;EACE,OAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;EACA,qBAAA;AADR;AAIM;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,OAAA;AAFR;AAIQ;EACE,aAAA;EACA,SAAA;AAFV;AAMM;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;AAJR;AAOM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;AALR;AAOQ;EACE,mBAAA;EACA,cAAA;EACA,WAAA;AALV;AAQQ;EACE,yBAAA;EACA,WAAA;AANV;AASQ;EACE,UAAA;EACA,QAAA;EACA,QAAA;AAPV;AAUQ;;EAEE,6BAAA;EACA,kBAAA;EACA,QAAA;AARV;AAYM;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,MAAA;AAVR;AAYQ;EACE,yDAAA;EACA,+BAAA;EACA,4BAAA;EACA,sBAAA;EACA,kBAAA;EAEA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;AAXV;AAyBQ;EACE,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;AAvBV;AA2BM;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;AAzBR;AA4BM;EACE,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;AA1BR;AA4BQ;EACE,2BAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;AA1BV;AA4BU;EACE,WAAA;EACA,cAAA;EACA,oBAAA;AA1BZ;AA6BU;EACE,yBAAA;EACA,WAAA;AA3BZ;AA8BU;EACE,gCAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AA5BZ;AAiCU;EACE,WAAA;AA/BZ;AAiCY;EACE,mBAAA;AA/Bd;AAwCQ;EACE,mBAAA;AAtCV;AAyCQ;EACE,UAAA;AAvCV;AA0CQ;EACE,aAAA;AAxCV;AA2CQ;EACE,qBAAA;EACA,eAAA;AAzCV;AA+CI;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,2BAAA;EACA,WAAA;AA7CN;AA8CM;EACE,WAAA;AA5CR;AAgDI;EACE,uBAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;AA9CN;AAgDM;EACE,WAAA;EACA,kBAAA;AA9CR;AAgDQ;EACE,kBAAA;AA9CV;AAkDM;EACE,kBAAA;AAhDR;AAkDQ;EACE,aAAA;AAhDV;AAoDM;EACE,UAAA;AAlDR;AAqDU;EACE,eAAA;AAnDZ","sourcesContent":[".menu {\n  background-color: #ab2429;\n  /*background-color: #eee;*/\n  min-height: 100%;\n\n  .app {\n    .main-header {\n      overflow: hidden;\n\n      &:before {\n        content: \"\";\n        display: block;\n        padding-bottom: 200%;\n        transition: padding 0.6s ease-in;\n      }\n\n      .back{\n        top: 5%;\n        left: 6%;\n        position: absolute;\n        z-index: 2;\n        text-decoration: none;\n      }\n\n      .menu-logo {\n        position: absolute;\n        width: 19%;\n        left: 50%;\n        transform: translateX(-50%);\n        top: 4%;\n\n        &.right {\n          left: inherit;\n          right: 6%;\n        }\n      }\n\n      .client-logo {\n        position: absolute;\n        width: 34%;\n        left: 11%;\n        top: 34%;\n      }\n\n      .placeholder {\n        position: absolute;\n        width: 42%;\n        left: 6%;\n        top: 29%;\n\n        &:before {\n          padding-bottom: 82%;\n          display: block;\n          content: \"\";\n        }\n\n        h1 {\n          font: 2.7em/1 vigaregular;\n          color: #fff;\n        }\n\n        .logo {\n          width: 86%;\n          left: 7%;\n          top: 50%;\n        }\n\n        h1,\n        .logo {\n          transform: translate(0, -50%);\n          position: absolute;\n          top: 50%;\n        }\n      }\n\n      .cover {\n        position: absolute;\n        overflow: hidden;\n        height: 100%;\n        width: 100%;\n        left: 0;\n        top: 0;\n\n        .image {\n          background-image: url(../../../public/images/bg-menu.jpg);\n          background-position: center top;\n          background-repeat: no-repeat;\n          background-size: cover;\n          position: absolute;\n          // filter: blur(2px);\n          max-height: 405px;\n          height: 100%;\n          width: 100%;\n          top: 0;\n          left: 0;\n\n          // &:after {\n          //   top: 0;\n          //   left: 0;\n          //   content: \"\";\n          //   width: 100%;\n          //   height: 100%;\n          //   position: absolute;\n          //   background: rgba(0, 0, 0, 0.3);\n          //   filter: blur(2px);\n          // }\n        }\n\n        .product {\n          background-image: url(\"../../../public/images/theme/products/super_bock.png\");\n          background-size: contain;\n          background-repeat: no-repeat;\n          background-position: 50%;\n          position: absolute;\n          max-height: 354px;\n          height: 100%;\n          width: 50%;\n          right: 0%;\n          top: 25%;\n          transition: all 750ms;\n        }\n      }\n\n      .not-published {\n        position: absolute;\n        display: flex;\n        opacity: 1;\n        width: 45%;\n        top: 56%;\n        left: 6%;\n      }\n\n      .lang {\n        transition: opacity 0.3s;\n        position: absolute;\n        display: flex;\n        opacity: 1;\n        width: 39%;\n        top: 56%;\n        left: 6%;\n\n        a {\n          font: 1.7em/1 \"vigaregular\";\n          background-color: #fff;\n          border-radius: 8px;\n          color: #caa36c;\n          margin: 5px;\n          width: 50%;\n\n          &::before {\n            content: \"\";\n            display: block;\n            padding-bottom: 100%;\n          }\n\n          &.active {\n            background-color: #caa36c;\n            color: #fff;\n          }\n\n          span {\n            transform: translate(-50%, -50%);\n            position: absolute;\n            left: 50%;\n            top: 50%;\n          }\n        }\n\n        &.solo {\n          a {\n            width: 100%;\n\n            &:before {\n              padding-bottom: 50%;\n            }\n          }\n        }\n      }\n    }\n\n    &.opened {\n      .main-header {\n        &::before {\n          padding-bottom: 82%;\n        }\n\n        .lang {\n          opacity: 0;\n        }\n\n        .note {\n          display: none;\n        }\n\n        .cover .product{\n          /*max-height: 180px;*/\n          max-height: 50%;\n        }\n\n      }\n    }\n\n    .note {\n      position: absolute;\n      bottom: 2%;\n      text-align: center;\n      width: 100%;\n      font: 1em/1.2em vigaregular;\n      color: #fff;\n      a {\n        color: #fff;\n      }\n    }\n\n    .areas {\n      transition: margin 0.5s;\n      margin-left: 0%;\n      display: flex;\n      width: 200%;\n\n      &.tab{\n        width: 300%;\n        margin-left: -100%;\n\n        &.opened{\n          margin-left: -200%;\n        }\n      }\n\n      &.opened {\n        margin-left: -100%;\n\n        section:first-child {\n          height: 100vh;\n        }\n      }\n\n      section {\n        width: 50%;\n\n        &.tab-detail{\n          .tabs{\n            margin-top: -5%;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
